import { render, staticRenderFns } from "./ModuleDetails.vue?vue&type=template&id=78744234"
import script from "./ModuleDetails.vue?vue&type=script&lang=js"
export * from "./ModuleDetails.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetails.vue?vue&type=style&index=0&id=78744234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports